import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { FormattedMessage } from 'react-intl'
import { Waypoint } from 'react-waypoint'

import { TrackingEventConstants } from '../../../constants/tracking'

import { getClientViewedDigest } from '../../../actions/clientEvents'
import { fetchRecommendations } from '../../../actions/recommendations'
import { selectClientId } from '../../../store/selectors/client'
import { selectShouldAttemptRenderRecommendations } from '../../../store/selectors/display'
import { selectHomeUuid } from '../../../store/selectors/home'
import { selectRecommendations } from '../../../store/selectors/recommendations'
import { IMPORTANT_NOW } from '../../../constants/document_ids'
import { useTrackingDebounceSetters } from '../../../hooks/tracking'

import { AsyncPanel, If, Text } from '../..'

import { useTrackingContext } from '../../../providers/tracking'
import styles from './ImportantNow.module.scss'
import { ImportantNowScrollView } from './ImportantNowScrollView'

const ImportantNow = () => {
  const dispatch = useDispatch()

  const { trackingClient } = useTrackingContext()

  const clientId = useSelector(selectClientId)
  const homeUuid = useSelector(selectHomeUuid)
  const recommendations = useSelector(selectRecommendations)
  const showPanel = useSelector(selectShouldAttemptRenderRecommendations)
  const [hidePanel, setHidePanel] = useState(false)

  const [trackModuleViewed] = useTrackingDebounceSetters(
    () => trackingClient?.moduleViewed({ module_name: TrackingEventConstants.WIN })
  )

  useEffect(() => {
    if (clientId && homeUuid) {
      dispatch(fetchRecommendations(clientId, homeUuid))
      dispatch(getClientViewedDigest(clientId))
    }
  }, [clientId, homeUuid, dispatch])

  const handleScrollIntoView = () => {
    trackModuleViewed()
  }

  return (
    <AsyncPanel
      data-qa='important-now-section'
      show={showPanel && !hidePanel}
      extraWide
      id={IMPORTANT_NOW}
      className={styles.panel}
      scrollMarginTop='var(--digest-module-scroll-margin-top)'
    >
      <Text element='h2' size='xl' weight='light' variant='neutralCool' variantCount='900' className={styles.title}>
        <FormattedMessage id='ImportantNow.title' defaultMessage="What's important now" />
      </Text>
      <If condition={showPanel}>
        <Waypoint onEnter={handleScrollIntoView} bottomOffset='50%' />
        <ImportantNowScrollView recommendations={recommendations} setHideParentPanel={setHidePanel} />
      </If>
    </AsyncPanel>
  )
}

ImportantNow.propTypes = {}

export default ImportantNow
